import { createContext } from 'react';

const HeaderThemeContext = createContext<[boolean, (isDark: boolean) => void]>([
	false,
	() => {},
]);

HeaderThemeContext.displayName = 'HeaderThemeContext';

export default HeaderThemeContext;
